export type LegalAcceptanceActionType = 'accept' | 'acknowledge' | 'consent';

export type LegalDocumentType = 'TermsOfUse' | 'PrivacyNotice' | 'Consent';

/**
 * Pre-authentication fallback documents (the registration flow is the Patient
 * pathway). Authenticated surfaces resolve the role-specific documents from the
 * legal requirements endpoint instead.
 */
export const DEFAULT_PUBLIC_LEGAL_DOCS: Record<'TermsOfUse' | 'PrivacyNotice', string> = {
    TermsOfUse: '/legal/AppMed_Patient_TermsOfUse_{LANG}_2026-10-01.md',
    PrivacyNotice: '/legal/AppMed_Patient_PrivacyNotice_{LANG}_2026-10-01.md',
};

export interface ILegalRequirement {
    documentType: string;
    version: string;
    action: LegalAcceptanceActionType;
    contentPathTemplate: string;
    accepted: boolean;
}

export interface ILegalRequirementsResponse {
    pathway: string | null;
    allAccepted: boolean;
    documents: ILegalRequirement[];
}

export interface IRecordLegalAcceptance {
    documentType: string;
    version: string;
    language: string;
}

export interface ILegalAcceptanceResponse {
    success: boolean;
    acceptedDate: string;
    allAccepted: boolean;
}

/**
 * Resolves the public URL of a legal document for a given language.
 * The backend returns a template such as
 * "/legal/AppMed_Patient_TermsOfUse_{LANG}_2026-06-01.md"; the language
 * placeholder is upper-cased (EN/FR) to match the file names on disk.
 */
export function resolveLegalContentUrl(contentPathTemplate: string, language: string): string {
    const lang = (language || 'en').slice(0, 2).toUpperCase();
    return contentPathTemplate.replace('{LANG}', lang);
}
